import { useContext } from "react";
import { langContext, agentContext, messageContext } from "commons/contexts";
import { BsFacebook, BsInstagram } from "react-icons/bs";
import { submitContactForm } from "commons/utils";

import style from "./style.module.scss";

interface props {
    refNo: string;
}
function ContactForm({ refNo }: props) {

    const { lang } = useContext(langContext);
    const { agentData } = useContext(agentContext);
    const msgCon = useContext(messageContext);


    const text: { [key: string]: { [key: string]: string } } = {
        nl: {
            title: "NEEM CONTACT MET ONS",
            left2: agentData.phone || "HIER KOMT UW TEL.NR.",
            left3: agentData.email || "HIER KOMT UW EMAIL ADRES",
            left4: agentData.address || "HIER KOMT UW ADRES",

            firstname: "VOORNAAM",
            lastname: "FAMILIENAAM",
            email: "EMAIL",
            phone: "TELEFOON",
            howcome: "HOE HEEFT U ONS LEREN KENNEN?",
            place5: "REFERENTIE VAN HET VASTGOED?",

            privacyText: "Ik geef toestemming om me te contacteren. Ik ga akkoord met de privacyverklaring en erken dat mijn gegevens worden verwerkt conform deze",
            privacyLink: "privacyverklaring.",

            sendButton: "VERZENDEN",
            bottom: "VOLG ONS"
        },
        fr: {
            title: "CONTACTEZ-NOUS",
            left2: "ICI VOTRE NUMERO DE TELEPHONE",
            left3: "ICI VOTRE ADRESSE EMAIL",
            left4: "ICI VOTRE ADRESSE",

            firstname: "PRÉNOM",
            lastname: "NOM DE FAMILLE",
            email: "EMAIL",
            phone: "TELEPHONE",
            howcome: "COMMENT VOUS NOUS AVEZ CONNUS?",
            place5: "REFERENCE DU BIEN IMMOBILIER?",

            privacyText: "Je donne l'autorisation de me contacter. Je suis d'accord avec la déclaration de confidentialité et reconnais que mes données seront traitées conformément à cette déclaration de confidentialité.",
            privacyLink: "CHARTE DE VIE PRIVÉE.",

            sendButton: "ENVOYER",
            bottom: "VOLG ONS"
        }
    }

    return <div className={style.root}>
        <div className={style.container}>
            <div className={style.form}>
                <div className={style.leftPart}>
                    <p className={style.title}>{text[lang]?.title || ""}</p>
                    <p>
                        {text[lang]?.left2 || ""}<br />
                        {text[lang]?.left3 || ""}
                    </p>
                    <p>
                        {text[lang]?.left4 || ""}<br />
                        {/* <u>Av. del Sol 225.</u><br />
                        29631 Benalmádena */}
                    </p>
                </div>

                <form className={style.rightPart} onSubmit={(e) => {
                    e.preventDefault();
                    submitContactForm(e.currentTarget, msgCon.setMessage, { ref: refNo });
                }}>
                    <input placeholder={(text[lang]?.firstname || "") + " *"} required name="firstname" />
                    <input placeholder={(text[lang]?.lastname || "") + " *"} required name="lastname" />
                    <input placeholder={(text[lang]?.email || "") + " *"} required name="email" />
                    <input placeholder={(text[lang]?.phone || "") + " *"} required name="phone" />
                    <input placeholder={(text[lang]?.howcome || "") + " *"} required name="howcome" />
                    {/* <input placeholder={(text[lang]?.place5 || "") + " *"} required name="ref"/> */}

                    <p>
                        {text[lang]?.privacyText || ""} <a href={`/${lang}/news/privacy-policy`} >{text[lang]?.privacyLink || ""}</a>.
                    </p>
                    <button className={style.button}>{text[lang]?.sendButton || ""}</button>
                </form>

            </div>

            {
                (lang !== "fr") && <div className={style.social}>
                    <div className={style.txt}>{text[lang]?.bottom || ""}</div>
                    <div className={style.icon}>
                        <BsFacebook />
                    </div>
                    <div className={style.icon}>
                        <BsInstagram />
                    </div>
                </div>
            }
            {/* <div className={style.footer}>
                © 2021 The Wave Beach SL.
                <div className={style.small}> Powered by GOMA brand narratives.</div>

                <div className={style.right}>
                    <div className={style.button}> Aviso legal </div>
                    |
                    <div className={style.button}> Privacidad </div>
                </div>
            </div> */}
        </div>
    </div>
}

export default ContactForm;